// import React from "react";
// import { Modal } from "antd";

// const ModalNoteDelete = ({
//   open,
//   setOpen,
//   onDeleteClick,
//   title = "Delete",
//   text = "Are you sure?",
//   okText = "Delete",
//   cancelText = "Cancel",
//   confirmLoading = false,
//   className,
//   forceDark = false,
// }) => {
//   const htmlHasDark =
//     typeof document !== "undefined" &&
//     document.documentElement.classList.contains("dark");

//   const isDark = forceDark || htmlHasDark || /\bdark\b/.test(className || "");

//   const styles = isDark
//     ? {
//         header: { background: "#1f2937", color: "#fff" },
//         content: { background: "#1f2937", color: "#fff" },
//         body: { background: "#1f2937", color: "#fff" },
//         footer: { background: "#1f2937", color: "#fff" },
//       }
//     : {
//         header: { background: "#fff", color: "#111827" },
//         content: { background: "#fff", color: "#111827" },
//         body: { background: "#fff", color: "#111827" },
//         footer: { background: "#fff", color: "#111827" },
//       };

//   return (
//     <Modal
//       title={title}
//       open={open}
//       onCancel={() => setOpen(false)}
//       onOk={onDeleteClick}
//       okText={okText}
//       cancelText={cancelText}
//       confirmLoading={confirmLoading}
//       styles={styles}
//       className={className}
//       wrapClassName={
//         isDark
//           ? `
//             dark
//             [&_.ant-modal-title]:!text-white
//             [&_.ant-modal-close]:!text-white
//             [&_.ant-modal-close-x]:!text-white
//             [&_.ant-modal-body]:!text-white
//           `
//           : ""
//       }
//       closeIcon={
//         <span
//           className={isDark ? "text-white" : "text-gray-700"}
//           style={{ fontSize: 18, lineHeight: 1 }}
//         >
//           ✕
//         </span>
//       }
//       okButtonProps={{
//         htmlType: "button",
//         danger: true,
//         style: isDark ? { color: "#fff" } : undefined,
//       }}
//       cancelButtonProps={{
//         htmlType: "button",
//         style: isDark
//           ? {
//               backgroundColor: "#374151",
//               color: "#fff",
//               borderColor: "#6b7280",
//             }
//           : undefined,
//       }}
//     >
//       <div className={isDark ? "!text-white" : "text-gray-900"}>{text}</div>
//     </Modal>
//   );
// };

// export default ModalNoteDelete;

import React from "react";
import { Modal } from "antd";

const ModalNoteDelete = ({
  open,
  setOpen,
  onDeleteClick,
  title = "Delete",
  text = "Are you sure?",
  okText = "Delete",
  cancelText = "Cancel",
  confirmLoading = false,
  className = "",
  forceDark = false,
}) => {
  const htmlHasDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");

  const isDark = forceDark || htmlHasDark || /\bdark\b/.test(className);

  // ✅ wrapClassName: hem light hem dark override
  const wrapCls = isDark
    ? `
      note-delete-modal
      [&_.ant-modal-content]:!bg-[#1f2937]
      [&_.ant-modal-header]:!bg-[#1f2937]
      [&_.ant-modal-body]:!bg-[#1f2937]
      [&_.ant-modal-footer]:!bg-[#1f2937]

      [&_.ant-modal-title]:!text-white
      [&_.ant-modal-close]:!text-white
      [&_.ant-modal-close-x]:!text-white
      [&_.ant-modal-body]:!text-white
      [&_.ant-modal-body_*]:!text-white

      /* Cancel (gri) */
      [&_.ant-btn-default]:!bg-[#374151]
      [&_.ant-btn-default]:!border-[#6b7280]
      [&_.ant-btn-default]:!text-white
      [&_.ant-btn-default:hover]:!bg-[#4b5563]

      /* OK/Delete (mavi) */
      [&_.ant-btn-primary]:!bg-[#0d72ca]
      [&_.ant-btn-primary]:!border-[#0d72ca]
      [&_.ant-btn-primary]:!text-white
      [&_.ant-btn-primary:hover]:!bg-[#0b5ea6]
      [&_.ant-btn-primary:hover]:!border-[#0b5ea6]
    `
    : `
      note-delete-modal
      [&_.ant-modal-content]:!bg-white
      [&_.ant-modal-header]:!bg-white
      [&_.ant-modal-body]:!bg-white
      [&_.ant-modal-footer]:!bg-white

      [&_.ant-modal-title]:!text-gray-900
      [&_.ant-modal-close]:!text-gray-900
      [&_.ant-modal-close-x]:!text-gray-900

      /* Body içindeki HER ŞEY siyah olsun */
      [&_.ant-modal-body]:!text-gray-900
      [&_.ant-modal-body_*]:!text-gray-900

      /* Cancel (gri) */
      [&_.ant-btn-default]:!bg-[#374151]
      [&_.ant-btn-default]:!border-[#6b7280]
      [&_.ant-btn-default]:!text-white
      [&_.ant-btn-default:hover]:!bg-[#4b5563]

      /* OK/Delete (mavi) */
      [&_.ant-btn-primary]:!bg-[#0d72ca]
      [&_.ant-btn-primary]:!border-[#0d72ca]
      [&_.ant-btn-primary]:!text-white
      [&_.ant-btn-primary:hover]:!bg-[#0b5ea6]
      [&_.ant-btn-primary:hover]:!border-[#0b5ea6]
    `;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={() => setOpen(false)}
      onOk={onDeleteClick}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      className={className}
      wrapClassName={wrapCls}
      closeIcon={
        <span
          className={isDark ? "!text-white" : "!text-gray-900"}
          style={{ fontSize: 18, lineHeight: 1 }}
        >
          ✕
        </span>
      }
      okButtonProps={{
        htmlType: "button",
        danger: false,     // ✅ mavi için danger kapalı
        type: "primary",   // ✅ primary mavi
      }}
      cancelButtonProps={{ htmlType: "button" }}
    >
      {/* text string de olsa JSX de olsa */}
      <div>{text}</div>
    </Modal>
  );
};

export default ModalNoteDelete;

